export const paddingX = ["40px", "30px", "20px", "10px", "5px"];
